import React from 'react'
import {US, OUT_OF_US} from "../../constants";

const Selection = ({selection, setSelection}) => {
    const handleSelection = (type) => {
        setSelection(type);
        localStorage.setItem("main_page_selection", type);
    }
    return (
        <>
            {/* product listing selection start */}
            <div className="bg-white bg-repeat-x bg-contain ">
                <div className=" py-4 md:w-2/4 lg:w-1/4 bg-blue-primary flex space-x-8">
                    {/* selection */}
                    <div className="cursor-pointer flex items-center lg:pl-8" onClick={() => handleSelection(OUT_OF_US)}>
                        <div className={`transition h-5 w-5 lg:h-8 lg:w-8 mr-2 border-2  border-white ${selection === OUT_OF_US ? 'bg-white' : ''}`}></div>
                        <span className={`block uppercase text-base xl:text-xl text-white ${selection === OUT_OF_US ? "font-bold" : "font-medium"}`}>Out of us</span>
                    </div>
                    {/* selection */}

                    {/* selection */}
                    <div className="cursor-pointer flex items-center" onClick={() => handleSelection(US)}>
                        <div className={`transition h-5 w-5 lg:h-8 lg:w-8 border-2 mr-2 ${selection === US ? 'bg-white' : ''}`}></div>
                        <span className={`block uppercase text-base xl:text-2xl text-white ${selection === US ? "font-bold" : "font-medium"}`}>Us</span>
                    </div>
                    {/* selection */}
                </div>
            </div>
            {/* product listing selection end */}  
        </>
    )
}

export default Selection
